<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    Resolve
    <select :value="selection" name="selection" class="form-control" @change="handleChange">
      <option value="all">all</option>
      <option value="most recent">most recent</option>
    </select>
    open
    <select :value="type" name="type" class="form-control" :class="{'is-invalid': errors.type}" @change="handleChange">
      <option value="" disabled>Select Incident Type</option>
      <option v-for="c in config.incidentTypes" :value="c">
        {{ c }}
      </option>
    </select>
    {{ selection == "all" ? 'incidents' : 'incident' }}
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String,
      type: String,
      selection: {
        type: String,
        default: "all"
      }
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.type) {
          this.errors.type = "Please select an incident type to resolve"
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
